import React from 'react';
import MinimumOffer from '../MinimumOffer';
import Countdown from '../Countdown';
import s from './MinOfferAndCountdown.scss';
const MinOfferAndCountdown = ({ adoptableState: { isSeller, minOfferPrice, canSeeEarlyAccessCountdown, earlyAccessCountdownHasEnded, earlyAccessCountdownEndTime, onEarlyAccessTimerEnd, canSeeOfferCountdown, offerCountdownHasEnded, onOfferTimerEnd, offerCountdownEndTime } })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: s['root']
    }, /*#__PURE__*/ React.createElement(MinimumOffer, {
        value: minOfferPrice
    }), /*#__PURE__*/ React.createElement("div", {
        role: "presentation",
        className: s['divider']
    }), (canSeeOfferCountdown || isSeller) && /*#__PURE__*/ React.createElement(Countdown, {
        hasEnded: offerCountdownHasEnded,
        countToDate: offerCountdownEndTime,
        onEnd: onOfferTimerEnd
    }), !isSeller && canSeeEarlyAccessCountdown && /*#__PURE__*/ React.createElement(Countdown, {
        isEarlyAccess: true,
        hasEnded: earlyAccessCountdownHasEnded,
        countToDate: earlyAccessCountdownEndTime,
        onEnd: onEarlyAccessTimerEnd
    }));
};
MinOfferAndCountdown.displayName = 'MinOfferAndCountdown';
export default MinOfferAndCountdown;

//# sourceMappingURL=MinOfferAndCountdown.js.map